/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AddUserGroupCommand } from '../models';
// @ts-ignore
import { GroupOverviewDto } from '../models';
// @ts-ignore
import { UpdateUserGroupCommand } from '../models';
// @ts-ignore
import { UserGroupDetailsDto } from '../models';
/**
 * UserGroupsApi - axios parameter creator
 * @export
 */
export const UserGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsAvailableNameGet: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiUserGroupsAvailableNameGet', 'name', name)
            const localVarPath = `/api/user-groups/available/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsNameDelete: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiUserGroupsNameDelete', 'name', name)
            const localVarPath = `/api/user-groups/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsNameGet: async (name: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiUserGroupsNameGet', 'name', name)
            const localVarPath = `/api/user-groups/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddUserGroupCommand} [addUserGroupCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsPost: async (addUserGroupCommand?: AddUserGroupCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUserGroupCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserGroupCommand} [updateUserGroupCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsPut: async (updateUserGroupCommand?: UpdateUserGroupCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserGroupCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupsApi - functional programming interface
 * @export
 */
export const UserGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupsAvailableNameGet(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupsAvailableNameGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupsNameDelete(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupsNameDelete(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupsNameGet(name: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserGroupDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupsNameGet(name, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddUserGroupCommand} [addUserGroupCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupsPost(addUserGroupCommand?: AddUserGroupCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupsPost(addUserGroupCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UpdateUserGroupCommand} [updateUserGroupCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGroupsPut(updateUserGroupCommand?: UpdateUserGroupCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGroupsPut(updateUserGroupCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserGroupsApi - factory interface
 * @export
 */
export const UserGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserGroupsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsAvailableNameGet(name: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiUserGroupsAvailableNameGet(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsGet(options?: any): AxiosPromise<Array<GroupOverviewDto>> {
            return localVarFp.apiUserGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsNameDelete(name: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiUserGroupsNameDelete(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsNameGet(name: string, options?: any): AxiosPromise<UserGroupDetailsDto> {
            return localVarFp.apiUserGroupsNameGet(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddUserGroupCommand} [addUserGroupCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsPost(addUserGroupCommand?: AddUserGroupCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUserGroupsPost(addUserGroupCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateUserGroupCommand} [updateUserGroupCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGroupsPut(updateUserGroupCommand?: UpdateUserGroupCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiUserGroupsPut(updateUserGroupCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiUserGroupsAvailableNameGet operation in UserGroupsApi.
 * @export
 * @interface UserGroupsApiApiUserGroupsAvailableNameGetRequest
 */
export interface UserGroupsApiApiUserGroupsAvailableNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserGroupsApiApiUserGroupsAvailableNameGet
     */
    readonly name: string
}

/**
 * Request parameters for apiUserGroupsNameDelete operation in UserGroupsApi.
 * @export
 * @interface UserGroupsApiApiUserGroupsNameDeleteRequest
 */
export interface UserGroupsApiApiUserGroupsNameDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof UserGroupsApiApiUserGroupsNameDelete
     */
    readonly name: string
}

/**
 * Request parameters for apiUserGroupsNameGet operation in UserGroupsApi.
 * @export
 * @interface UserGroupsApiApiUserGroupsNameGetRequest
 */
export interface UserGroupsApiApiUserGroupsNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UserGroupsApiApiUserGroupsNameGet
     */
    readonly name: string
}

/**
 * Request parameters for apiUserGroupsPost operation in UserGroupsApi.
 * @export
 * @interface UserGroupsApiApiUserGroupsPostRequest
 */
export interface UserGroupsApiApiUserGroupsPostRequest {
    /**
     * 
     * @type {AddUserGroupCommand}
     * @memberof UserGroupsApiApiUserGroupsPost
     */
    readonly addUserGroupCommand?: AddUserGroupCommand
}

/**
 * Request parameters for apiUserGroupsPut operation in UserGroupsApi.
 * @export
 * @interface UserGroupsApiApiUserGroupsPutRequest
 */
export interface UserGroupsApiApiUserGroupsPutRequest {
    /**
     * 
     * @type {UpdateUserGroupCommand}
     * @memberof UserGroupsApiApiUserGroupsPut
     */
    readonly updateUserGroupCommand?: UpdateUserGroupCommand
}

/**
 * UserGroupsApi - object-oriented interface
 * @export
 * @class UserGroupsApi
 * @extends {BaseAPI}
 */
export class UserGroupsApi extends BaseAPI {
    /**
     * 
     * @param {UserGroupsApiApiUserGroupsAvailableNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public apiUserGroupsAvailableNameGet(requestParameters: UserGroupsApiApiUserGroupsAvailableNameGetRequest, options?: AxiosRequestConfig) {
        return UserGroupsApiFp(this.configuration).apiUserGroupsAvailableNameGet(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public apiUserGroupsGet(options?: AxiosRequestConfig) {
        return UserGroupsApiFp(this.configuration).apiUserGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserGroupsApiApiUserGroupsNameDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public apiUserGroupsNameDelete(requestParameters: UserGroupsApiApiUserGroupsNameDeleteRequest, options?: AxiosRequestConfig) {
        return UserGroupsApiFp(this.configuration).apiUserGroupsNameDelete(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserGroupsApiApiUserGroupsNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public apiUserGroupsNameGet(requestParameters: UserGroupsApiApiUserGroupsNameGetRequest, options?: AxiosRequestConfig) {
        return UserGroupsApiFp(this.configuration).apiUserGroupsNameGet(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserGroupsApiApiUserGroupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public apiUserGroupsPost(requestParameters: UserGroupsApiApiUserGroupsPostRequest = {}, options?: AxiosRequestConfig) {
        return UserGroupsApiFp(this.configuration).apiUserGroupsPost(requestParameters.addUserGroupCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserGroupsApiApiUserGroupsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApi
     */
    public apiUserGroupsPut(requestParameters: UserGroupsApiApiUserGroupsPutRequest = {}, options?: AxiosRequestConfig) {
        return UserGroupsApiFp(this.configuration).apiUserGroupsPut(requestParameters.updateUserGroupCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
